import { Modal } from "../ui/modal/Modal"
import { useState } from "react"
import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"
import { useQuery } from "../../hooks/useQuery"
import { Trans, useTranslation } from "react-i18next"
import { Switch } from "../ui/Switch"
import toast from "react-hot-toast"

export const ModalNuevoJuegoRow = ({ show, setEntries }) => {
  const [id, setId] = useState(""),
    [enabled, setEnabled] = useState(false)

  const query = useQuery()

  const runQuery = async () => {
    const game = { id, enabled }

    const tkn = getCookie("jwt"),
      { url, opt } = api.game_management.create({ token: tkn, game })

    query.url.current = url
    query.opt.current = opt

    query.run({
      onOk: () => {
        setEntries((currents) => currents.concat(game))
        toast.success(
          <span>
            <Trans
              i18nKey="admin.games.has_been_created"
              values={{ name: id }}
              components={{ i: <i /> }}
            />
          </span>
        )
        show[1](false)
      },
      onErr: () => {
        toast.error(t(`ui.msgs.something_went_wrong`))
      },
    })
  }

  const { t } = useTranslation()

  const body = () => {
    return (
      <>
        <div className="p-3 pt-0" style={{ background: "hsl(0deg 0% 90%)" }}>
          <div className="form-group">
            <label className="form-label mt-4">ID</label>
            <input
              onChange={(e) => {
                setId(e.target.value)
              }}
              value={id}
              className="form-control"
              placeholder="ID"
            />
          </div>

          <div className="form-group d-flex align-items-center mt-4">
            <label className="form-label mt-2 me-3">
              {t(`admin.games.enabled`)}
            </label>
            <Switch status={enabled} setStatus={setEnabled} />
          </div>
        </div>
      </>
    )
  }

  const footer = () => {
    const handleCancelar = () => show[1](false)
    return (
      <>
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => handleCancelar()}
        >
          {t(`ui.btns.cancel`)}
        </button>

        <button
          type="button"
          className="btn btn-primary"
          disabled={query.isPending}
          onClick={() => runQuery()}
        >
          {query.isPending
            ? t(`ui.btns.submiting`) + "..."
            : t(`ui.btns.create`)}
        </button>
      </>
    )
  }

  return (
    <>
      <Modal
        id="nuevo-juego"
        show={show}
        header={<center>{t(`modals.modal_create_game_row.header`)}</center>}
        body={body()}
        footer={footer()}
      />
    </>
  )
}
